import 'angular-sticky-plugin';

import register from '@kpsys/angularjs-register';
import GenerateFullWidthMenuDirective from './helpers/kp-generate-full-width-menu.directive';
import GenerateSideMenuDirective from './helpers/kp-generate-side-menu.directive';
import MainMenuLogoImageComponent from './main-menu-logo-image/kp-main-menu-logo-image.component';
import MainMenuLogoComponent from './main-menu-logo/kp-main-menu-logo.component';
import MainMenuNavComponent from './main-menu-nav/kp-main-menu-nav.component';
import MainMenuServiceProvider from './main-menu.provider';

import MainMenuComponent from './main-menu/kp-main-menu.component';
import SideMenuComponent from './side-menu/kp-side-menu.component';

/**
 * @ngdoc module
 * @name portaro.components.main-menu
 * @module portaro.components.main-menu
 */

export default register('portaro.components.main-menu', ['hl.sticky', 'ngAnimate', 'ui.bootstrap'])
    .component(MainMenuComponent.componentName, MainMenuComponent)
    .component(MainMenuNavComponent.componentName, MainMenuNavComponent)
    .component(MainMenuLogoComponent.componentName, MainMenuLogoComponent)
    .component(SideMenuComponent.componentName, SideMenuComponent)
    .component(MainMenuLogoImageComponent.componentName, MainMenuLogoImageComponent)
    .directive(GenerateFullWidthMenuDirective.directiveName, GenerateFullWidthMenuDirective)
    .directive(GenerateSideMenuDirective.directiveName, GenerateSideMenuDirective)
    .provider(MainMenuServiceProvider.providerName, MainMenuServiceProvider)
    .name();

/**
 * @ngdoc type
 * @name singleMenuItem
 * @typedef {Object} singleMenuItem
 *
 * @property {string} text
 */

/**
 * @ngdoc type
 * @name multiMenuItem
 * @typedef {object} multiMenuItem
 *
 * @property {string} text
 * @property {singleMenuItem[]} submenu
 */

/**
 * @ngdoc type
 * @name menuItems
 * @typedef {Array.<singleMenuItem|multiMenuItem>} menuItems
 */